import Ventas from './Ventas';
export default Ventas;